import api from './api';
import { storageService } from './storageService';

export const authService = {
  login: async (username, password) => {
    console.log("asdfasdfasdf",process.env.REACT_APP_API_URL);
    try {
      const response = await api.post('/auth/login', { username, password });
      const { token, data,success,message } = response.data;
      if (!success) {
        console.log("alshfkjas",response.data,message)
        throw new Error(message || 'Login failed');
      }
      console.log("user data>>>",response.data,token,data)
      const modifiedData = {...data , token}
      storageService.setToken(token);
      storageService.setUser(data);
      
      return modifiedData;
    } catch (error) {
      console.log("saldkjfaldsf",error)
      throw new Error(error );
    }
  },
  
  register: async (userData) => {
    try {
      const response = await api.post('/auth/register', userData);
      return response.data;
      

    } catch (error) {
      return error.response.data ;
    }
  },
  
  logout: async () => {
    try {
      // await api.post('/auth/logout');
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      // Always clear local storage on logout
      storageService.clearAuth();
    }
  },
  
  getCurrentUser: async () => {
    // First try to get from local storage
    const user = storageService.getUser();
    console.log("user>>>>",user)
    if (user) {
      return user;
    }
    
  },
  
  forgotPassword: async (email) => {
    try {
      // const response = await api.post('/auth/forgot-password', { email });
      // return response.data;
      
      // Dummy data
      return {
        message: 'Password reset link sent to your email'
      };
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Password reset request failed');
    }
  },
  
  resetPassword: async (token, newPassword) => {
    try {
      // const response = await api.post('/auth/reset-password', { 
      //   token, 
      //   password: newPassword 
      // });
      // return response.data;
      
      // Dummy data
      return {
        message: 'Password reset successful'
      };
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Password reset failed');
    }
  }
};